import styled, { css } from 'styled-components';

type ZillowNavbarSectionContainerProps = {
    isVertical: boolean;
};
export const ZillowNavbarSectionContainer = styled.li<ZillowNavbarSectionContainerProps>`
    height: calc(100% + 2px);
    vertical-align: middle;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    ${({ isVertical }) =>
        css`
            ${isVertical &&
            css`
                // only position relative when vertical since the megamenu should be relative to the navbar when it is
                // not vertical.
                position: relative;
            `}
        `}
`;
